import { Container } from '@/components/ui/Container';
import { siteConfig } from '@/data/site';

export const Footer = () => (
  <footer className="site-footer">
    <Container>
      <div className="site-footer__grid">
        <div className="site-footer__col">
          <h2>{siteConfig.name}</h2>
          <p>{siteConfig.description}</p>
        </div>

        <div className="site-footer__col">
          <h3>Feeds</h3>
          <a href="/rss">RSS</a>
          <a href="/sitemap">Sitemap</a>
        </div>
      </div>

      <div className="site-footer__colophon">
        <p>© {new Date().getFullYear()} PublishWeaver. All rights reserved.</p>
        <p>Built with care for editorial teams.</p>
      </div>
    </Container>
  </footer>
);
